import React from "react";
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { displayDialog } from "store/actions/utilActions";
//#region components
import { Icon } from "components/common";
import { Badge, Grid } from "@mui/material";
import CommentsFormContainer from "../forms/commentsFormContainer";
//#endregion
//#region types
import { FormFieldConstants, IconDefinitionConstants } from "utils/constants";
import { CommentsCountFieldProps } from "models/propTypes/timeReportingPropTypes";
import { TranslationKeys } from "translations";
import { DialogEnums } from "models/enums";
import { useFormikContext } from "formik";
import { TimeReportingFormTypes } from "models/formTypes";
//#endregion
import clsx from "clsx";
import cssExports from "theme/styles/main.module.scss";
import { FormHelper, LocalizationHelperInstance } from "utils/helpers";
import { TimeReportType } from "models/enums/timeReporting";

const CommentsCountField: React.FC<CommentsCountFieldProps> = (props) => {
  const { value, name, tableHeaderValues, weekLockEntries, currentWeekDateRange } = props;

  const fieldInfo = FormHelper.getTableRowFieldInfo(name ?? "");
  const { values, setFieldValue } = useFormikContext<TimeReportingFormTypes.WeeklyTimeReport>();

  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  const isDataRow = React.useMemo(() => {
    return fieldInfo?.rowIndex !== undefined;
  }, []);

  const row = React.useMemo(() => {
    return fieldInfo && values.rows[fieldInfo?.rowIndex];
  }, [values.rows]);

  const onCommentsFormSubmit = (vals: TimeReportingFormTypes.WeekComments) => {
    const rows = [...values.rows];

    const updatedRows = rows.map((row, index) => {
      if (index !== fieldInfo?.rowIndex) {
        return row;
      } else {
        return { ...row, comments: vals };
      }
    });

    setFieldValue(FormFieldConstants.TimeReporting.WeeklyTimeReport.Rows, updatedRows);
  };

  const onCommentsIconClick = () =>
    dispatch(
      displayDialog({
        isOpen: false,
        title: `${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.TimeReporting.Comments)} ${row?.name}`,
        subTitle: row?.categoryName,
        titleIcon: IconDefinitionConstants.WCommentDots,
        dialogType: DialogEnums.DialogType.Content,
        actions: [
          {
            text: "OK",
          },
        ],
        children: (
          <CommentsFormContainer
            values={row?.comments}
            tableHeaderValues={tableHeaderValues}
            row={row}
            weekLockEntries={weekLockEntries}
            currentWeekDateRange={currentWeekDateRange}
          />
        ),
        onSubmit: onCommentsFormSubmit,
      })
    );

  const commentsCount = React.useMemo(() => {
    const comments = row?.comments;

    return comments ? Object.values(comments).filter((val) => val !== undefined && val.length > 0).length : 0;
  }, [row]);

  return isDataRow && row?.type === TimeReportType.project ? (
    <Grid container justifyContent="flex-end">
      <Grid item className={cssExports.removeDisable}>
        <Badge
          badgeContent={commentsCount}
          classes={{ badge: cssExports.filterCount, root: cssExports.commentsBadge }}
          onClick={onCommentsIconClick}
        >
          <Icon
            className={clsx(value === 0 ? cssExports.commentsCountFieldEmpty : cssExports.commentsCountFieldFilled)}
            icon={IconDefinitionConstants.WCommentDots}
          />
        </Badge>
      </Grid>
    </Grid>
  ) : (
    <></>
  );
};

export default CommentsCountField;
